module.exports = {
      id: "news-usage",
      viewBox: "0 0 24.597 24.597",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#news",
      toString: function () {
        return this.url;
      }
    }